import React from 'react';
import style from './ErrorMessage.module.scss';

interface ErrorComponentProps  {
    children: React.ReactNode
}

const ErrorComponent : React.FC<ErrorComponentProps> = (props : ErrorComponentProps)=> {
    const {children} = props;
    return <div className={ style["error-message"]}>{children}</div>
}

export default ErrorComponent;